import { Link } from "react-router-dom"
import { Head } from "vite-react-ssg"

import { Button } from "@/components/ui/button"

/**
 * 404 — friendly catch-all.
 *
 * Tells crawlers + browsers this is a "not found" via the meta robots
 * tag; the host responds with the actual 404 status code (Cloudflare
 * Pages / Netlify / nginx all support a `404.html` convention which
 * vite.config.ts wires up via includedRoutes).
 */
export function Component() {
  return (
    <>
      <Head>
        <title>Page not found — Good Talk</title>
        <meta name="robots" content="noindex" />
      </Head>
      <section className="container flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
        <p className="text-sm font-semibold uppercase tracking-wider text-primary">
          404
        </p>
        <h1 className="mt-4 text-4xl font-bold tracking-tight sm:text-5xl">
          We couldn&rsquo;t find that page
        </h1>
        <p className="mt-4 max-w-md text-muted-foreground">
          The link might be old, or the page might have moved. Head back to
          the home page and try again from there.
        </p>
        <Button asChild className="mt-8" size="lg">
          <Link to="/">Back to home</Link>
        </Button>
      </section>
    </>
  )
}
